module.exports = __webpack_public_path__ + "img/28.fa2f7d5f.png";